import { render, staticRenderFns } from "./CrmRelationshipTreeSettings.vue?vue&type=template&id=fc41cbe4"
import script from "./CrmRelationshipTreeSettings.vue?vue&type=script&lang=js"
export * from "./CrmRelationshipTreeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports